import { gql } from 'graphql-request'

export const CHECK_CLIENT_IS_EXIST = gql`
  query CheckClientIsExist($email: String!) {
    checkClientIsExist(email: $email)
  }
`
